//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('components', {
//        templateUrl: 'views/components/views/components/components.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'componentsService', 'ttGridFactory', 'layoutService', function ($stateParams, stateService, utilityService, componentsService, ttGridFactory, layoutService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let prodId = $stateParams.prod_id;
//            let onDestroy = [];

//            vm.model = {
//                tabletSize: layoutService.getMediaQueries().tablet,
//                gridReady: false,
//                bgCompFunction: {
//                    selected: 'EDIT',
//                    buttons: [
//                        { id: 'EDIT', label: 'gb_compfunction_edit', color: 'primary', onClick: () => setCompFunctionView('EDIT') },
//                        { id: 'COMPONENTS', label: 'gb_compfunction_components', color: 'primary', onClick: () => setCompFunctionView('COMPONENTS') }
//                    ]
//                },
//                productIdButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('product', { prod_id: vm.model.setting.prod_id }) }
//                ],
//                setting: {},
//                itemsListComponent: []
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: 'w_components_grid',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            }).setCustomToolbarButtons([{
//                name: 'components_add',
//                text: 'components_add',
//                func: () => {
//                    stateService.go('component', {
//                        prod_id: prodId,
//                        comp_keyno: '0'
//                    });
//                },
//                icon: 'fa-plus',
//                cssClass: 'btn btn-primary im-grid-btn-xs-r',
//                translate: true
//            }]);

//            // #endregion VARIABLES & DEFINITIONS

//            // #region SET VALUE BUTTON RADIO FUNCTION

//            function setCompFunctionView(id) {
//                vm.model.bgCompFunction.selected = vm.model.setting.gb_compfunction = id;
//            }

//            // #endregion  VALUE BUTTON RADIO FUNCTION

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSetting() {
//                vm.model.setting = (await componentsService.getSetting({ prod_id: prodId }))[0];
                
//                if (vm.model.tabletSize.matches === true) {
//                    return loadGrid();
//                } else {
//                    setCompFunctionView(vm.model.setting.gb_compfunction);
//                    return loadComponents();
//                }
//            }
            
//            async function loadComponents() {
//                if (utilityService.validateParmsValue(vm.model.setting.prod_id) !== true) return;
//                if (utilityService.validateParmsValue(vm.model.setting.gb_compfunction) !== true) return;

//                vm.model.itemsListComponent = [];

//                return vm.model.itemsListComponent = await componentsService.listComponents({
//                    prod_id: vm.model.setting.prod_id,
//                    gb_compfunction: vm.model.setting.gb_compfunction
//                });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region GRID PROCEDURE FUNCTION CALLS

//            async function loadGrid() {
//                if (utilityService.validateParmsValue(vm.model.setting.prod_id) !== true) return;

//                vm.grid.dataTask.loadData = {
//                    method: 3743,
//                    parameters: { prod_id: vm.model.setting.prod_id }
//                };

//                vm.model.gridReady = true;

//                if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//            }

//            // #endregion GRID PROCEDURE FUNCTION CALLS

//            // #region BUTTON RADIO FUNCTION

//            vm.selectBgCompFunction = function (value) {
//                vm.model.bgCompFunction.selected = value;
//                vm.model.setting.gb_compfunction = vm.model.bgCompFunction.selected;

//                if (vm.model.tabletSize.matches === false) return loadComponents();
//            }

//            // #endregion BUTTON RADIO FUNCTION

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'component':
//                        go({
//                            prod_id: prodId,
//                            comp_keyno: '0'
//                        });
//                        break;
//                    default:
//                        break;
//                }
//            };

//		    // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON WINDOW RESIZE FUNCTION

//            async function onWindowResize() {
//                if (vm.model.tabletSize.matches === true) {
//                    return loadGrid();
//                } else {
//                    return loadComponents();
//                }
//            }

//            // #endregion ON WINDOW RESIZE FUNCTION

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadSetting();

//            	window.addEventListener('resize', onWindowResize);
//            	onWindowResize();
//            }

//            // #endregion ON INIT FUNCTION

//            // #region DESTROY FUNCTION

//            vm.$onDestroy = function () {
//            	window.removeEventListener('resize', onWindowResize);

//            	onDestroy.forEach((fn) => {
//            		if (typeof fn === 'function') fn();
//            	});
//            }

//            // #endregion DESTROY FUNCTION

//        }]
//    });
//})();
